import React, { useCallback } from "react";
import { QuestionsIF } from "./QuestionsIF";
import {
  ConversationQuestionType,
  QualifiedFeature,
  QuestionChoiceType,
} from "fe-common/graphql";
import { useTranslate } from "../../hooks/useTranslate";
import { ClosedMultipleQuestionView } from "./ClosedMultipleQuestionView";
import { SymptomText } from "../uiControllers/SymptomText";

// Hardcodded for now, dont show more than 8 items in a closed multiple question
const MAX_ITEMS_PER_QUESTION = 8;

export function ClosedMultipleQuestion(props: QuestionsIF) {
  const suggestions = props.question?.suggestions?.map((s) => s.suggestion);

  const { translate } = useTranslate();

  const handleDone = (selected) => {
    const answer: QualifiedFeature[] = [];

    selected.forEach(([qualifiedFeature, isSelected]) => {
      answer.push({
        ...qualifiedFeature,
        negate: !isSelected,
      });
    });

    props.onAnswer(answer);
  };

  const getSymptomText = useCallback(
    (qf: QualifiedFeature) => {
      const suggestion = props.question.suggestions.find(
        (suggestion) => suggestion.suggestion.id === qf.id,
      );
      if (suggestions) {
        return (
          <SymptomText
            symptom={qf}
            mutualInformation={suggestion.mutualInformation}
          />
        );
      }
    },
    [suggestions, props.question.suggestions],
  );

  return (
    <ClosedMultipleQuestionView
      questionsText={
        props.question?.question?.text ||
        (props.question.questionType ===
        ConversationQuestionType.BackgroundSuggestion
          ? translate("QUESTION_MULTIPLE")
          : translate("QUESTION_MULTIPLE_SYMPTOMS"))
      }
      answer={props.answer?.qfs}
      suggestions={suggestions}
      onDone={handleDone}
      labeler={getSymptomText}
      maxItems={MAX_ITEMS_PER_QUESTION}
      singleSelect={
        props.question.questionChoiceType === QuestionChoiceType.ChooseOne
      }
      basedOnReasoning={props.question.basedOnReasoning}
      isBackgroundQuestion={
        props.question.questionType ===
        ConversationQuestionType.BackgroundSuggestion
      }
      miniView={props.miniView}
    />
  );
}
